import { API } from '@base/core';
import { useQuery } from 'react-query';

export function useGetFormSubmissions(campaignId: string) {
  return useQuery(['campaigns', campaignId, 'submissions'], async () => {
    return await API.campaigns.getFormViewerContents(campaignId);
  });
}
